// extracted by mini-css-extract-plugin
module.exports = {"template":"ImageAndTextList_template___taBB"};